








import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component<BorderCard>({})
export default class BorderCard extends Vue {
  @Prop({ type: String })
  borderColor: string;

  @Prop({ type: String, default: 'white' })
  color: string;

  @Prop({ type: [String, Number], default: 1 })
  borderWidth: number | string;

  get style(): Partial<CSSStyleDeclaration> {
    return {
      padding: `${this.borderWidth}px !important`,
    };
  }
}
